import type { ReactNode } from 'react';

type Props = {
  label: ReactNode;
  children: ReactNode;
  color: string;
};

export const FairValueHistogramTooltipRow = ({
  label,
  children,
  color,
}: Props) => {
  return (
    <>
      <div className="text-tiny" style={color ? { color } : {}}>
        {label}
      </div>
      <div className="text-right text-tiny">{children}</div>
    </>
  );
};
